import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { RouteService } from '../../services/route.service';
import { CommonService } from '../../services/common.service';
import { Observable } from 'rxjs/Observable';
import { any } from "codelyzer/util/function";
import { AlertService } from '../../services/alert.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.css']
})
export class RouteComponent implements OnInit {
  routeById: any = {};
  temportalInterestPoint: any = {};
  interestPointList: any = [];
  rfids: any = [];
  messageResult: any;
  pageTitle: string = "Ruta no Encontrada";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private routeService: RouteService,
    private commonService: CommonService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    // this.routeUserAccount = this.route.snapshot.params.idRoute;
    this.getRoute();
    this.getRfids();
    console.log(this.interestPointList)
  }

  getRoute(): void {
    try {
      this.route.paramMap.switchMap((params: ParamMap) => this.routeService.getRoute(params.get('idRoute')))
        .subscribe(response => {
          console.log(response)
          console.log('response ;: ', response[0].divipol_code)
          this.routeById.Description = response[0].description;
          this.routeById.Id = response[0].id;
          this.routeById.Status = response[0].status;
          this.routeById.User_account = response[0].user_account;
          this.routeById.Divipol_code = response[0].divipol_code;
          this.routeById.Travel_time = response[0].travel_time;
          this.routeById.Name = response[0].name;
          this.routeById.Distance = response[0].distance;
          this.routeById.Forward_or_back = response[0].forward_or_back;

          this.pageTitle = "Editanto Ruta - " + this.routeById.Divipol_code
          this.getInterestPoints();
        });
    } catch (error) {

    }
  }

  removePoint(interestPointId){
    let that = this
    this.routeService.deleteInterestPoints(interestPointId)
      .then(response => {
        that.getInterestPoints()
        swal({
          title: "Borrado!",
          text: 'El Punto de Interés fue Borrado Exitosamente',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
      })
      .catch(response => {
        swal({
          title: "Ops!",
          text: 'Ocurrió un error al borrar el Punto de Interes',
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
      })
  }

  getInterestPoints() {
    this.routeService.getInterestPoints(this.routeById.Id)
      .then(response => {
        this.interestPointList = []
        for(var i in response){
          this.interestPointList.push({ id: response[i].interest_point_id, 
                                        name: response[i].name, 
                                        distance: response[i].distance_from_start 
                                      })
        }
      })
      .catch(response => {
        swal({
          title: "Ops!",
          text: 'Ocurrió un error al recuperar los Puntos de Interes. Por favor recargue la página',
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
      })
  }

  saveInterestPoint() {
    let that = this
    if (this.temportalInterestPoint.Name == undefined || this.temportalInterestPoint.Name == "") {
      swal({
        title: "Error",
        text: 'Debe ingresar un Nombre para el Punto',
        type: 'info',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
      return
    }

    if (this.temportalInterestPoint.Distance == undefined || this.temportalInterestPoint.Distance == "") {
      swal({
        title: "Error",
        text: 'Debe ingresar una Distancia para el Punto',
        type: 'info',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
      return
    }
    this.temportalInterestPoint.RouteId = this.routeById.Id

    this.routeService.saveInterestPoint(this.temportalInterestPoint)
      .then(response => {
        swal({
          title: "Guardado!",
          text: 'El Punto de Interés fue guardado Exitosamente',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
        this.temportalInterestPoint = {}
        that.getInterestPoints()

      })
      .catch(response => {
        swal({
          title: "Ops!",
          text: 'Ocurrió un error al procesar su solicitud. Intente nuevamente',
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
      })
  }

  getRfids(): void {
    this.route.paramMap.switchMap((params: ParamMap) => 
      this.routeService.getRfids(params.get('idRoute')))
            .subscribe(response => {
              this.rfids = response;
            });
  }

  updateRoute(idRoute): void {
    console.log("this.routeById : ", this.routeById)
    console.log(this.routeById.Forward_or_back)
    if(this.routeById.Forward_or_back == undefined){
      swal({
        title: "Atención!",
        text: 'Debe Seleccionar el Tipo de Ruta',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
      return
    }
    this.routeService.updateRoute(this.routeById)
      .then(response => {
        if (response) {
          // this.router.navigate(['/home/routes']);
          if (response.status === 'EXITO') {
            swal({
              title: response.message,
              text: '',
              type: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#ff5370',
              confirmButtonText: 'Volver',
              // cancelButtonText: 'No'
            }).catch(swal.noop);

          } else {
            this.alertService.error(response.message);
            console.log('this.alertService.error(response.message);', response.message);
          }
        }
      });
  }



}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/route/route.component.ts